/* eslint-disable */
export default {
  pendingStart: 'Pending',
  inProgress: 'InProgress',
  completed: 'Completed',
  completedWithErrors: 'CompletedWithErrors',
  failed: 'Failed'
};

